(function () {
  Flint.file("views/pages/homePage.js", function (require) {
    Flint.staticStyles("HomePage", {
      "$": "#_flintapp .ViewHomePage",
      "$home": "#_flintapp home.HomePage, #_flintapp .HomePage.home, #_flintapp .ViewHomePage.home, #_flintapp .HomePage > .home",
      "$header": "#_flintapp header.HomePage, #_flintapp .HomePage.header, #_flintapp .ViewHomePage.header, #_flintapp .HomePage > .header",
      "$section": "#_flintapp section.HomePage, #_flintapp .HomePage.section, #_flintapp .ViewHomePage.section, #_flintapp .HomePage > .section",
      "$sHeading": "#_flintapp sHeading.HomePage, #_flintapp .HomePage.sHeading, #_flintapp .ViewHomePage.sHeading, #_flintapp .HomePage > .sHeading",
      "$sTagline": "#_flintapp sTagline.HomePage, #_flintapp .HomePage.sTagline, #_flintapp .ViewHomePage.sTagline, #_flintapp .HomePage > .sTagline",
      "$sBody": "#_flintapp sBody.HomePage, #_flintapp .HomePage.sBody, #_flintapp .ViewHomePage.sBody, #_flintapp .HomePage > .sBody",
      "$girlsGameBody": "#_flintapp girlsGameBody.HomePage, #_flintapp .HomePage.girlsGameBody, #_flintapp .ViewHomePage.girlsGameBody, #_flintapp .HomePage > .girlsGameBody",
      "$textingTipsBody": "#_flintapp textingTipsBody.HomePage, #_flintapp .HomePage.textingTipsBody, #_flintapp .ViewHomePage.textingTipsBody, #_flintapp .HomePage > .textingTipsBody",
      "$imgLogo": "#_flintapp imgLogo.HomePage, #_flintapp .HomePage.imgLogo, #_flintapp .ViewHomePage.imgLogo, #_flintapp .HomePage > .imgLogo",
      "$textingTipsLogo": "#_flintapp textingTipsLogo.HomePage, #_flintapp .HomePage.textingTipsLogo, #_flintapp .ViewHomePage.textingTipsLogo, #_flintapp .HomePage > .textingTipsLogo",
      "$girlsGameLogo": "#_flintapp girlsGameLogo.HomePage, #_flintapp .HomePage.girlsGameLogo, #_flintapp .ViewHomePage.girlsGameLogo, #_flintapp .HomePage > .girlsGameLogo",
      "$carouselCard": "#_flintapp carouselCard.HomePage, #_flintapp .HomePage.carouselCard, #_flintapp .ViewHomePage.carouselCard, #_flintapp .HomePage > .carouselCard"
    }, {
      "$": {
        marginBottom: 60
      },
      "$home": {},
      "$header": {
        marginTop: 24,
        alignSelf: 'stretch',
        alignItems: 'center',
        marginBottom: 30,
        paddingLeft: 24,
        paddingRight: 24
      },
      "$section": {
        marginTop: 50,

        alignItems: 'stretch'
      },
      "$sHeading": {
        flexDirection: 'row',
        alignItems: 'center',

        marginBottom: 8
      },
      "$sTagline": {
        fontStyle: 'italic',
        color: '#666',
        marginLeft: 30
      },
      "$sBody": {
        minHeight: 100,
        flexGrow: 1,
        alignItems: 'stretch'
      },
      "$girlsGameBody": {
        background: 'linear-gradient(to bottom, #da5275 0%, #fd8eab 100%)'
      },
      "$textingTipsBody": {
        background: 'linear-gradient(to bottom, #0057b3 0%, #218ffa 100%)'
      },
      "$imgLogo": {
        width: 400,
        height: 47,
        marginRight: 50
      },
      "$textingTipsLogo": {
        width: 250
      },
      "$girlsGameLogo": {},
      "$carouselCard": {
        alignSelf: 'stretch',
        flexGrow: 1
      }
    });
    Flint.view("HomePage", function (view, on, $) {
      var context = initContext(view, {
        width: atom(),
        isMobile: atom()
      });

      var cardWidth = derivation(function () {
        return context.isMobile.get() ? context.width.get() : 600;
      });
      var cardHeight = derivation(function () {
        return cardWidth.get() * 9 / 16;
      });

      on.mount(function () {
        M.mixpanel.track("PageView", { page: 'home' });
      });view.render(function () {
        return view.el(["NavBar", 1], null);
      });view.render(function () {
        return view.el(
          ["home", 1],
          null,
          Flint.iff(!context.isMobile.get()) && view.el(
            ["header", 1],
            { if: !context.isMobile.get() },
            view.el(["img", 1], { className: "imgLogo", src: "/images/pr-logo.png" })
          ),
          view.el(
            ["HeroCarousel", 1],
            null,
            view.el(["MrRightCard", 1], { className: "carouselCard" }),
            view.el(["TsaCard", 1], { className: "carouselCard" }),
            view.el(["EmrCard", 1], { className: "carouselCard" }),
            view.el(["TextingTipsCard", 1], { className: "carouselCard" })
          ),
          view.el(
            ["section", 1],
            null,
            view.el(
              ["sHeading", 1],
              null,
              view.el(
                ["Link", 1],
                { to: "http://thegirlsgame.tv", target: "_blank" },
                view.el(["img", 2], { className: "girlsGameLogo", src: "/images/girlsgame.png" })
              ),
              Flint.iff(!context.isMobile.get()) && view.el(
                ["sTagline", 1],
                { if: !context.isMobile.get() },
                "Real dating advice for women"
              )
            ),
            view.el(
              ["sBody", 1],
              { className: "girlsGameBody" },
              view.el(["GirlsGameEmbeds", 1], {
                style: {
                  width: context.width.get()
                }
              })
            )
          ),
          view.el(
            ["section", 2],
            null,
            view.el(
              ["sHeading", 2],
              null,
              view.el(
                ["Link", 2],
                { to: "https://texting.tips", target: "_blank" },
                view.el(["img", 3], { className: "textingTipsLogo", src: "/images/textingtips.png" })
              ),
              Flint.iff(!context.isMobile.get()) && view.el(
                ["sTagline", 2],
                { if: !context.isMobile.get() },
                "Tap into modern romance"
              )
            ),
            view.el(
              ["sBody", 2],
              { className: "textingTipsBody" },
              view.el(["TextingTipsEmbeds", 1], {
                style: {
                  width: context.width.get()
                }
              })
            )
          )
        );
      });view.render(function () {
        return view.el(["Footer", 1], null);
      });

      $["$"] = function (_, _index) {
        return {
          width: context.width.get() };
      };

      $["home"] = function (_, _index) {
        return {
          padding: context.isMobile.get() ? 0 : [16, 0, 50]
        };
      };

      "cf6a5dc0";
      "8064c836";

      $["section"] = function (_, _index) {
        return { width: context.width.get() };
      };

      "535acd7a";

      $["sHeading"] = function (_, _index) {
        return { justifyContent: context.isMobile.get() ? 'center' : 'flex-start',
          paddingLeft: context.isMobile.get() ? 0 : 20 };
      };

      "4afdb400";
      "489147ba";
      "6f80434c";
      "4ba1a8d4";
      "9f423c9a";
      "9f424a68";

      $["textingTipsLogo"] = function (_, _index) {
        return { height: 250 / 4.17
        };
      };

      $["girlsGameLogo"] = function (_, _index) {
        return {
          width: context.isMobile.get() ? 200 : 250,
          height: 120 / 642 * (context.isMobile.get() ? 200 : 250)
        };
      };

      "9f424a68";
    });
  })
})();
//# sourceMappingURL=homePage.js.map
